import { createReducer, on } from '@ngrx/store';
import { liveLessonAuthActions } from '@pcp/auth';

export const authFeatureKey = 'pcpLiveAuth';

export interface PcpLiveAuthState {
    isLogginIn?: boolean;
    loginFailedReason?: string;
    user?: {
        pcpToken: string;
        pcpTokenExpiresAt: number;
        pcpGroupId: string;
        azureToken: string;
        azureGroupId: string;
        displayName: string;
        threadId: string;
    };
}

export const initialState: PcpLiveAuthState = {};

// TODO: still needed after the transition to the new AuthService?
// TODO: delete the whole LiveLesson-AuthState
export const reducer = createReducer(
    initialState,
    on(
        liveLessonAuthActions.userLoginRequested,
        (state, action): PcpLiveAuthState => ({
            ...state,
            isLogginIn: true,
            loginFailedReason: undefined,
            user: undefined,
        }),
    ),
    on(
        liveLessonAuthActions.userLoginFailed,
        (state, action): PcpLiveAuthState => ({
            ...state,
            isLogginIn: false,
            loginFailedReason: 'login failed...',
        }),
    ),
    on(
        liveLessonAuthActions.userLoginSuccess,
        liveLessonAuthActions.tokenRestoreSuccess,
        (state, { tokenData }): PcpLiveAuthState => ({
            ...state,
            isLogginIn: false,
            loginFailedReason: undefined,
            user: {
                azureGroupId: tokenData.liveLesson.azureCommunicationGroupId,
                azureToken: tokenData.liveLesson.azureCommunicationToken,
                displayName: tokenData.liveLesson.displayName,
                pcpGroupId: tokenData.liveLesson.pcpSignalrGroupId,
                pcpToken: tokenData.token,
                pcpTokenExpiresAt: tokenData.liveLesson.exp,
                threadId: tokenData.liveLesson.threadId,
            },
        }),
    ),
);
